import React, { Component } from 'react';
import { graphql, createRefetchContainer, requestSubscription } from 'react-relay';
import { Dialog, DialogContent, DialogActions, } from '@material-ui/core';
import { withStyles } from '@material-ui/styles';
import useStyles from './styles';
import environment from '../../environment';

class FishLeaderboardResult extends Component {
    constructor(props){
        super(props);
        this.state = {
            open: false,
            openDialog: false,
            selectedTeam: null,
            selectedTeamPoints: 0,
            selectedData: [],
            points_per_team: [],
            all_answers: [],
        }

        this.expandTeam = this.expandTeam.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this._refetch = this._refetch.bind(this);
    }

    componentDidMount(){
        const data = this.props.getFishLeaderboard.getFishLeaderboard.data;
        this.setState({
            points_per_team: data.points_per_team,
            all_answers: data.all_answers,
        });
        const event_token = this.props.variables.event_token;
        const subscriptionConfig = {
            subscription: graphql`
                subscription FishLeaderboardResultSubscription($event_token: String!){
                    updateFishLeaderboard(event_token: $event_token){
                        event_token
                    }
                }
            `,
            variables: { event_token: event_token },
            onError: error => console.log("Subscription error : ", error),
            updater: store => {
                this.props.refetchData();
            }
        };
        this.subscription = requestSubscription(environment, subscriptionConfig);
    }

    componentWillUnmount(){
        this.subscription.dispose();
    }

    _refetch = () => {
        const event_token = this.props.variables.event_token;
        this.props.relay.refetch(
            {
                event_token: event_token,
            },
            null,
            () => { },
            { force: true }
        );
    }

    expandTeam(n, points){
        const all_answers = this.state.all_answers;
        
        const selectedData = all_answers.filter(a => a.group_id == n);

        this.setState({
            open: true,
            selectedTeam: n,
            selectedTeamPoints: points,
            selectedData: selectedData,
        });
    }

    handleClose(){
        this.setState({
            open: false,
            selectedTeam: null,
        });
    }

    render(){
        const { classes, disclaimer } = this.props;
        const { open, selectedTeam, selectedTeamPoints, selectedData, points_per_team } = this.state;

        return ([
            <table className={classes.fishTable} key='fishleaderboard_table'>
                <thead>
                    <tr>
                        <th style={{width: '15%', textAlign: 'center', fontWeight: 'normal'}}>
                            Place
                        </th>
                        <th style={{width: '65%', textAlign: 'left', fontWeight: 'normal'}}>
                            Team
                        </th>
                        <th style={{width: '20%', textAlign: 'center', fontWeight: 'normal'}}>
                            Points
                        </th>
                    </tr>
                </thead>
                <tbody>
                {
                    points_per_team.map((team, i) => (
                        <tr key={`place-${i}`}>
                            <td style={{width: '20%', textAlign: 'center'}}>
                                <span className={classes.placeNum}>{team.position}</span>
                            </td>
                            <td style={{width: '60%', textAlign: 'left'}}>
                                <span className={classes.teamName}>Team {team.group_id}</span>
                                <span className={classes.expandText} onClick={() => this.expandTeam(team.group_id, team.points)}>expand →</span>
                            </td>
                            <td style={{width: '20%', textAlign: 'center'}}>
                                <span className={classes.points}>{team.points}</span>
                            </td>
                        </tr>
                    ))
                }
                </tbody>
            </table>,
            <Dialog
                open={open}
                onClose={this.handleClose}
                maxWidth='lg'
                hideBackdrop
                key='fishleaderboard_dialog'
            >
                <DialogContent>
                    <table className={classes.teamTable}>
                        <thead>
                            <tr>
                                <th style={{width: '85%', textAlign: 'left'}}>
                                    Team {selectedTeam}
                                </th>
                                <th style={{width: '15%', textAlign: 'center', color: '#00A8B6'}}>
                                    {selectedTeamPoints} pts
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            selectedData.map((d, i) => (
                                <tr key={`Team-member-${i}`}>
                                    <td style={{width: '85%', textAlign: 'left'}}>
                                        {d.guest.guest_name}
                                    </td>
                                    <td style={{width: '15%', textAlign: 'center'}}>
                                        {d.points} pts
                                    </td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </table>
                </DialogContent>
                <DialogActions>
                    <button className={classes.dialogClButton} onClick={this.handleClose}>
                        close
                    </button>
                </DialogActions>
            </Dialog>
        ])
    }
}

export default createRefetchContainer(
    withStyles(useStyles)(FishLeaderboardResult),
    {
        getFishLeaderboard: graphql`
            fragment FishLeaderboardResult_getFishLeaderboard on Query
                @argumentDefinitions(event_token: { type: "String!" }) {
                    getFishLeaderboard(event_token: $event_token) {
                        code
                        message
                        data {
                          points_per_team {
                            group_id
                            points
                            position
                          }
                          all_answers {
                            group_id
                            points
                            guest {
                              guest_name
                            }
                          }
                        }
                    }
                }
        `
    },
    graphql`
        query FishLeaderboardResultRefetchQuery($event_token: String!){
            ...FishLeaderboardResult_getFishLeaderboard
                @arguments(event_token: $event_token)
        }
    `
);